import { getToken, getLoginPhone } from '@/common/auth'

export default {

  courses: [], // 课程列表
  courseWrapper: {}, // 课程和视频的集合
  payInfo: {}, // 支付信息

  orderConfirmWrapper: {}, // 待支付订单信息wrapper
  loginSource: 1, // 发起登录的页面 1-Index 2-Course
  phone: getLoginPhone(), // 顾客手机号码
  token: getToken(), // 后台系统返回的token

  navCollapse: 1, // 导航是否折叠1-不折叠 2-折叠
  wrapperWidth: 82, // 导航是否折叠1-不折叠 2-折叠
}



// WEBPACK FOOTER //
// ./src/store/state.js